import { LoadingButton } from '@mui/lab';
import { Container, FormControlLabel, FormGroup, Grid, Switch, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { Form, FormikProvider, useFormik } from 'formik';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { headerType } from 'src/Helpers/constant';
import { instructorServices } from 'src/Services/WebApiHandler/instructorServices';
import MyEditor from 'src/components/common/Editor';
import * as Yup from 'yup';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function InstructorHeaderModal({ open, setOpen, bookId, headerdata, getChapterHeader }) {
  const [stateData, setStateData] = useState({ data: '' });

  const userValues = {
    header_name: '',
    public_visibility: false,
  };

  const userSchema = Yup.object().shape({
    header_name: Yup.string().required('header name is required'),
    // public_visibility: Yup.bool().required('Visibility is required'),
  });

  const formik = useFormik({
    initialValues: userValues,
    validationSchema: userSchema,

    onSubmit: (values) => {
      if (headerdata.type === headerType.header1) {
        let Header1postData = {
          book_slug_clone: headerdata?.data.book_slug_clone || headerdata?.data.book_slug,
          chapter_slug_clone: headerdata?.data.slug,
          book_id_clone: bookId,
          chapter_id_clone: headerdata?.data._id,
          header1_name_clone: values.header_name,
          header1_content_clone: stateData.data,
          public_visibility: values.public_visibility,
        };

        if (stateData?.data) {
          instructorServices
            .instructorHeaderOneCreate(Header1postData)
            .then((response) => {
              if (response.code === 201) {
                setOpen(false);
                toast.success(response.message);
                getChapterHeader();
                setFieldValue(`header_name`, '');
                setFieldValue(`public_visibility`, false);
                setStateData({ data: '' });
              } else {
                toast.success(response.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }

      if (headerdata.type === headerType.header2) {
        let Header2postData = {
          book_slug_clone: headerdata?.data.book_slug_clone,
          chapter_slug_clone: headerdata?.data.chapter_slug_clone,
          header1_slug_clone: headerdata?.data.slug,
          book_id_clone: bookId,
          header1_id_clone: headerdata?.data?._id,
          header2_name_clone: values.header_name,
          header2_content_clone: stateData.data,
          public_visibility: values.public_visibility,
        };

        if (stateData?.data) {
          instructorServices
            .instructorHeaderTwoCreate(Header2postData)
            .then((response) => {
              if (response.code === 201) {
                setOpen(false);
                getChapterHeader();
                toast.success(response.message);
                setFieldValue(`header_name`, '');
                setFieldValue(`public_visibility`, false);
                setStateData({ data: '' });
              } else {
                toast.success(response.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }

      if (headerdata.type === headerType.header3) {
        let Header3postData = {
          book_slug_clone: headerdata?.data.book_slug_clone,
          chapter_slug_clone: headerdata?.data.chapter_slug_clone,
          header1_slug_clone: headerdata?.data.header1_slug_clone,
          header2_slug_clone: headerdata?.data.slug,
          book_id_clone: bookId,
          header2_id_clone: headerdata?.data?._id,
          header3_name_clone: values.header_name,
          header3_content_clone: stateData.data,
          public_visibility: values.public_visibility,
        };
        if (stateData?.data) {
          instructorServices
            .instructorHeaderThreeCreate(Header3postData)
            .then((response) => {
              if (response.code === 201) {
                setOpen(false);
                toast.success(response.message);
                getChapterHeader();
                setFieldValue(`header_name`, '');
                setFieldValue(`public_visibility`, false);
                setStateData({ data: '' });
              } else {
                toast.success(response.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
  });

  const onEditorChange = (e) => {
    setStateData({
      data: e.getData(),
    });
  };

  const { values, errors, touched, handleSubmit, getFieldProps, setFieldValue } = formik;
  const handleClose = () => {
    setOpen(false);
    setFieldValue(`header_name`, '');
    setFieldValue(`public_visibility`, false);
    setStateData({ data: '' });
  };

  return (
    <Dialog fullWidth maxWidth={'lg'} open={open} onClose={handleClose} TransitionComponent={Transition}>
      <section className="mt-5">
        <Container>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="row justify-content-between">
                <div className="col-md-9">
                  <TextField
                    fullWidth
                    autoComplete="username"
                    type="text"
                    label="Header Name"
                    value={values.header_name}
                    {...getFieldProps('header_name')}
                    error={Boolean(touched.header_name && errors.header_name)}
                    helperText={touched.header_name && errors.header_name}
                  />
                </div>

                <div className="col-md-3">
                  <FormGroup>
                    <FormControlLabel
                      control={<Switch checked={values.public_visibility} {...getFieldProps('public_visibility')} />}
                      label="Public Visibility"
                    />
                  </FormGroup>
                </div>

                <div className="col-md-12 mt-3">
                  <MyEditor onEditorChange={onEditorChange} />
                  {!stateData?.data && (
                    <small className="text-danger mt-0" style={{ colorr: '#FF4842', fontSize: '0.75rem' }}>
                      content is required
                    </small>
                  )}
                </div>

                <Grid container spacing={2} sx={{ my: 3 }}>
                  <Grid item xs={6}>
                    <LoadingButton
                      size="large"
                      type="button"
                      variant="contained"
                      color="error"
                      onClick={() => handleClose()}
                    >
                      Close
                    </LoadingButton>
                  </Grid>
                  <Grid item xs={6} className="text-end">
                    <LoadingButton size="large" type="submit" variant="contained">
                      Submit
                    </LoadingButton>
                  </Grid>
                </Grid>
              </div>
            </Form>
          </FormikProvider>
        </Container>
      </section>
    </Dialog>
  );
}
